export function PrivacyPolicyStructuredData() {
  const baseUrl = "https://beatview.ai";

  const breadcrumbList = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: baseUrl,
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Privacy Policy",
        item: `${baseUrl}/privacy-policy`,
      },
    ],
  };

  const webPage = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Privacy Policy - Beatview",
    description:
      "Learn how Beatview protects your data and respects your privacy. Our comprehensive privacy policy covers data collection, usage, and your rights under GDPR and CCPA.",
    url: `${baseUrl}/privacy-policy`,
    isPartOf: {
      "@type": "WebSite",
      name: "Beatview",
      url: baseUrl,
    },
    publisher: {
      "@type": "Organization",
      name: "Beatview",
      url: baseUrl,
    },
    dateModified: "2026-01-29",
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbList) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPage) }}
      />
    </>
  );
}
